export const GROUP_VALIDATION_RULES = {
  name: {
    isRequiredTrim: {
      value: true,
    },
    maxLength: {
      value: 128,
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/dashboard/admin/groups/groupValidationRules.js